import React, { Component, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchProduct } from 'Catalog/Product/ducks'
import { getProductBySku } from 'Catalog/Product/ProductDetail/reducer'
import Availability, { IfAvailable } from 'Catalog/Availability'
import { ProductImage } from 'Catalog/Product/ProductDetail/DetailSection/ProductImage'
import { Payment } from 'Catalog/Product/ProductDetail/RedemptionSection/Payment'
import { Voucher } from 'Catalog/Product/ProductDetail/RedemptionSection/Voucher'
import { ProductTabs } from 'Catalog/Product/ProductDetail/DetailSection/ProductTabs'
import { Feature } from 'Catalog/Product/ProductDetail/RedemptionSection/Feature'
import AddCartVerify from 'Catalog/Product/ProductDetail/RedemptionSection/AddCartVerify'

import Tagging from 'Catalog/Product/ProductCard/Tagging'

import { ShippingContainer } from 'Catalog/Product/ProductDetail/RedemptionSection/Shipping'
import ShippingPlaceholder from 'Catalog/Product/ProductDetail/RedemptionSection/Shipping/ShippingPlaceholder'
import MediaQuery from 'react-responsive'
import ReactPlaceholder from 'react-placeholder'
import { ItemToItemContainer } from 'features/Recomendation'

import Helmet from 'react-helmet'
import FingerPrintContainer from 'App/FingerPrint/FingerPrintContainer'

import '@loyal_template/products.css'
import IsResponsiveEnabledContext from 'Shared/IsResponsiveEnabledContext'

import * as Sentry from '@sentry/browser'

const ProductBrandDisplay = ({ name }) => (
  <p className='h3 txt-brand-product txt-body txt-font-body color-brand-1 txt-uppercase mb-1' aria-label={`Marca: ${name}`}>
    {name}
  </p>
)

ProductBrandDisplay.propTypes = {
  name: PropTypes.string
}

const ProductBrandDisplayContainer = connect(
  ({ brands }, { brandId }) => brands[brandId]
)(ProductBrandDisplay)

const ProductNameDisplay = ({ name }) => (
  <h1 className='txt-title-product txt-font-body color-ui-2'>
    {name}
  </h1>
)

ProductNameDisplay.propTypes = {
  name: PropTypes.string
}

const showProductContext = (actualContext, vendorContext) => {
  return actualContext === vendorContext
}

showProductContext.propTypes = {
  actualContext: PropTypes.bool,
  vendorContext: PropTypes.bool
}

const VendorDisplay = ({ name, imageUrl }) => (
  <div className='row border-color-ui-3 border-bottom mx-0 py-2 px-3 card-price'>
    <div className='row product-brand w-100'>
      <div className='col-7'>
        <h2 className='txt-info-product txt-body txt-font-body color-brand-1 txt-uppercase mb-1 h3'>
          SOBRE A LOJA
        </h2>
        <p className='txt-body-sm'>
          <span aria-hidden='true'>Fornecido e entregue por: <strong>{name}</strong></span>
          <span className='hide-absolute'>Fornecido e entregue por: {name}</span>
        </p>

      </div>
      {imageUrl && (
        <div className='card-brand col-5 txt-right'>
          <img className='img-w-auto img-w-90 img-h-90' src={imageUrl} alt={name} aria-hidden='true' />
        </div>
      )}
    </div>
  </div>
)

VendorDisplay.propTypes = {
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string
}

const VendorDisplayContainer = connect(
  ({ vendors }, { vendorId }) => vendors[vendorId]
)(VendorDisplay)

const ProductDetail =
  ({ sku, originalId, vendorId, brandId, name, description, images, imageUrl, productFeatures, detail, isOnlyCash, sendCart, clickSendCart }) => {
    useEffect(() => {
      window._etmc.push(['setOrgId', '6422293'])
      window._etmc.push(['trackPageView', { 'item': originalId }])
    }, [])

    return (
      <div className='container-product container pt-0 pt-md-5 pb-0 pb-lg-3'>
        <FingerPrintContainer />
        <Helmet>
          <title>{` ${name} - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        {
          sendCart && <Tagging type='clickProduct' identifier='productPage' position='0' sku={sku} name={name} vendorId={vendorId} originalId={originalId} />
        }

        <Tagging type='viewProduct' identifier='productPage' position='0' sku={sku} name={name} vendorId={vendorId} originalId={originalId} />

        <div className='row'>
          <div className='product-side col-12 col-lg-7 pr-0 pl-0 pl-md-1 pr-md-2'>
            <div className='border-ui-3 radius pb-3 pb-lg-0  bg-white pt-1 pos-relative'>
              <ProductImage sku={sku} images={images} imageUrl={imageUrl} />
              {description && (
                <MediaQuery minDeviceWidth={1025}>
                  <ProductTabs
                    isVoucher={detail && detail.isVoucher}
                    isPhysicalVoucher={detail && detail.isPhysicalVoucher}
                    description={description}
                    properties={productFeatures.filter(feat => feat.type === 'CARACTERÍSTICAS')}
                    specs={productFeatures.filter(feat => feat.type === 'ESPECIFICAÇÕES TÉCNICAS')}
                  />
                </MediaQuery>
              )}
            </div>
          </div>
          <div className='product-side col-12 col-lg-5  mt-4 mt-lg-0'>
            <div className='border-ui-3 radius bg-white px-0 py-0'>
              <div className='product-infos col-12 pt-3 px-3 mx-0'>
                <ProductBrandDisplayContainer brandId={brandId} />
                <ProductNameDisplay name={name} />
              </div>
              {detail && (
                <Feature
                  isVoucher={detail.isVoucher}
                  isPhysicalVoucher={detail.isPhysicalVoucher}
                  features={detail.skuFeaturesByType || {}}
                  SkuByType={detail.SkuByType}
                />
              )}
              <div className='row border-color-ui-3 border-bottom mx-0 py-2 px-3 card-price'>
                <div className='row product-brand w-100'>
                  <div className='col-12'>
                    {vendorId && originalId && sku && (
                      <IsResponsiveEnabledContext.Provider value={false}>
                        <Availability sku={sku} originalId={originalId} vendorId={vendorId} changeContext={detail && detail.onlyCash !== undefined ? showProductContext(isOnlyCash, detail.onlyCash) : true} />
                      </IsResponsiveEnabledContext.Provider>
                    )}
                  </div>
                  <div className='col-12 button-area' onClick={() => clickSendCart()}>
                    <IfAvailable sku={sku}>
                      <AddCartVerify sku={sku} vendorId={vendorId} hasVoltage={detail && typeof detail.skuFeaturesByType !== 'undefined' ? typeof detail.skuFeaturesByType.VOLTAGEM !== 'undefined' : false} changeContext={detail && detail.onlyCash !== undefined ? !showProductContext(isOnlyCash, detail.onlyCash) : false} />
                    </IfAvailable>
                  </div>
                </div>
              </div>
              <VendorDisplayContainer vendorId={vendorId} />
              <Voucher visible={detail && detail.isVoucher} />
              <IfAvailable sku={sku} component={Payment} />
              <ReactPlaceholder ready={!!detail} customPlaceholder={<ShippingPlaceholder />}>
                {detail && showProductContext(isOnlyCash, detail.onlyCash) &&
                <ShippingContainer
                  productSkuId={sku}
                  isVoucher={detail && detail.isVoucher}
                  isPhysicalVoucher={detail && detail.isPhysicalVoucher}
                  pointsName={detail && detail.pointsName}
                />}
              </ReactPlaceholder>
              {description && (
                <MediaQuery maxDeviceWidth={1024}>
                  <ProductTabs
                    isVoucher={detail && detail.isVoucher}
                    isPhysicalVoucher={detail && detail.isPhysicalVoucher}
                    description={description}
                    properties={productFeatures.filter(feat => feat.type === 'CARACTERÍSTICAS')}
                    specs={productFeatures.filter(feat => feat.type === 'ESPECIFICAÇÕES TÉCNICAS')}
                  />
                </MediaQuery>
              )}
            </div>
          </div>
        </div>
        { process.env.REACT_APP_HAS_RECOMMENDATION_SHOWCASE && ((detail && !isOnlyCash) ? <ItemToItemContainer productId={detail.productId} /> : '')}
      </div>
    )
  }
ProductDetail.propTypes = {
  clickSendCart: PropTypes.func,
  sendCart: PropTypes.bool,
  sku: PropTypes.string,
  originalId: PropTypes.string,
  vendorId: PropTypes.string,
  brandId: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  images: PropTypes.array,
  imageUrl: PropTypes.string,
  productFeatures: PropTypes.array,
  detail: PropTypes.shape({
    isVoucher: PropTypes.bool,
    isPhysicalVoucher: PropTypes.bool,
    skuFeaturesByType: PropTypes.object,
    SkuByType: PropTypes.array,
    payment: PropTypes.object,
    pointsName: PropTypes.string,
    productId: PropTypes.string,
    onlyCash: PropTypes.bool
  }),
  isOnlyCash: PropTypes.bool
}

class ProductDetailContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      clickSendCart: false
    }
    this.clickSendCart = this.clickSendCart.bind(this)
  }

  handleDetailUpdate () {
    const { loadProductDetail, detail } = this.props
    !detail && loadProductDetail()
  }

  async componentDidMount () {
    this.handleDetailUpdate()
  }

  componentDidUpdate () {
    this.handleDetailUpdate()
  }

  render () {
    const { loadProductDetail: _, ...props } = this.props
    Sentry.captureMessage('Product Detail Test for Pentest')

    return <ProductDetail sendCart={this.state.clickSendCart} clickSendCart={this.clickSendCart} {...props} />
  }

  clickSendCart () {
    this.setState({ clickSendCart: true })
  }
}

ProductDetailContainer.propTypes = {
  loadProductDetail: PropTypes.func,
  isLoading: PropTypes.bool,
  detail: PropTypes.object,
  isOnlyCash: PropTypes.bool
}

const mapStateToProps = ({ onlyCash: isOnlyCash, productsv2: products, ...state }, ownProps) => {
  const { match: { params: { sku } } } = ownProps

  return { isOnlyCash, sku, ...products[sku], detail: getProductBySku(state, sku) }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { match: { params: { sku } } } = ownProps
  return {
    loadProductDetail: () => dispatch(fetchProduct(sku))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailContainer)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/ProductDetailPageContainer.js